import { S3Client, GetObjectCommand, PutObjectCommand } from '@aws-sdk/client-s3';
import { AWSCredentials } from './cognitoService';

const S3_REGION = 'eu-west-1';
const S3_BUCKET = process.env.REACT_APP_S3_BUCKET || 'wokingcarboot-website-code-deploy';
const S3_KEY = 'resources/latest/woking.txt';

export async function fetchContent(credentials: AWSCredentials): Promise<string> {
  const s3Client = new S3Client({
    region: S3_REGION,
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken,
    },
  });

  try {
    const response = await s3Client.send(
      new GetObjectCommand({
        Bucket: S3_BUCKET,
        Key: S3_KEY,
      })
    );

    if (!response.Body) {
      return '';
    }

    const text = await response.Body.transformToString();
    return text;
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : 'Failed to fetch content from S3'
    );
  }
}

export async function saveContent(
  credentials: AWSCredentials,
  content: string
): Promise<void> {
  const s3Client = new S3Client({
    region: S3_REGION,
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken,
    },
  });

  try {
    await s3Client.send(
      new PutObjectCommand({
        Bucket: S3_BUCKET,
        Key: S3_KEY,
        Body: content,
        ContentType: 'text/plain',
      })
    );
  } catch (error) {
    throw new Error(
      error instanceof Error ? error.message : 'Failed to save content to S3'
    );
  }
}
